import React, { useEffect, useState } from 'react';
import './ListCircleMenu.css';
import CircleMenu from '../CircleMenu/CircleMenu';

import Cookies from 'js-cookie'; // Для работы с куками
import { getTokensFromCookies } from '../../api/AuthApi';
import { crateTokenAcc, fetchMyOrganizationMyAccounts } from '../../api/orgsApi';
import { getWorkplaceUser } from '../../api/staffApi';
import { ReactComponent as CRM } from '../../images/crm.svg';
import { ReactComponent as ProductionIcon } from '../../images/production.svg';


const ListCircleMenu = ({
  isActiveCircleMenu,
  handleSelectedBlock,
  isAuthenticated,
  myOrganisationList,
  toggleMenu,
}) => {
  const [myOrgList, setMyOrgList] = useState(myOrganisationList);
  const [isActiveCircleMenuTwo, setIsActiveCircleMenuTwo] = useState('');

  useEffect(() => {
    setMyOrgList(() =>
      myOrganisationList.map((org) => ({
        ...org,
        icon: org.label ? org.label.charAt(0).toUpperCase() : '?', // Берём первую букву и делаем её заглавной
      }))
    );
    myOrganisationList.length > 0
      ? setIsActiveCircleMenuTwo('menu-2')
      : setIsActiveCircleMenuTwo(null);
    toggleMenu('menu-1');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myOrganisationList]);

  if (!isAuthenticated) return <></>;

  const menuItems = [
    {
      icon: '🏠',
      label: 'Главная',
    },
    {
      icon: '📞',
      label: 'Контакты',
    },
    {
      icon: '🛒',
      label: 'Multimarket',
      authStatus: true,
    },
    {
      key: 'messenger',
      icon: '📧',
      label: 'МЕССЕНДЖЕР',
      subItems: [],
    },
  ];

  const handleMenuItemClick = (item) => {
    const { a_token, r_token } = getTokensFromCookies();

    if (item.label === 'Multimarket') {
      if (!a_token || !r_token) {
        console.warn('Токены отсутствуют. Перенаправление невозможно.');
        handleSelectedBlock('sign-in');
        return;
      }

      try {
        const marketUrl = new URL(window.APP_CONFIG?.MARKET_DOMAIN);
        marketUrl.searchParams.set('a_token', a_token);
        marketUrl.searchParams.set('r_token', r_token);

        window.location.href = marketUrl.toString();
      } catch (e) {
        console.error('Ошибка при формировании MARKET_DOMAIN:', e);
      }
    } else if (item.key === 'messenger') {
      handleClickMessenger();
    } else if (item.key === 'crm') {
      // Редирект
      window.location.href = 'https://crm.multi-mir.ru/';
    }
  };

  //   const handleMenuClickSeller = async (newOrganization) => {
  //     if (!newOrganization?.id) {
  //       console.warn('Некорректная организация.');
  //       return;
  //     }
  //     try {
  //       // const res = await fetchMyOrganizationMyAccounts(newOrganization.id);

  //       const workplace = await getWorkplaceUser();
  //       console.log(workplace);
  // const
  //       const subItems = [
  //         {
  //           label: 'БАЗА МАТЕРИАЛОВ',
  //           user_id: '415364d154aw187d175aw1d418aw6d145',
  //           icon: 'БМ',
  //           organization_id: newOrganization.id,
  //         },
  //       ];

  //       // res.data.map((acc) => ({
  //       //   label: acc.name,
  //       //   user_id: acc.user_id,
  //       //   icon: acc.name ? acc.name.charAt(0).toUpperCase() : '?',
  //       //   organization_id: newOrganization.id,
  //       // }));
  //       setMyOrgList((prev) =>
  //         prev.map((org) =>
  //           newOrganization.id === org.id ? {...org, subItems} : org
  //         )
  //       );
  //     } catch (error) {}
  //   };
  const handleMenuClickSeller = async (newOrganization) => {
    if (!newOrganization?.id) {
      console.warn('Некорректная организация.');
      return;
    }
    try {
      const workplace = await getWorkplaceUser();

      // Находим организацию по ID в данных с бэкенда
      const currentOrganization = workplace.data.find(
        (org) => org.organisation_id === newOrganization.id
      );

      // Создаем subItems из workplaces найденной организации
      const subItems = [
        ...(Array.isArray(currentOrganization?.workplaces)
          ? currentOrganization.workplaces.map((workplace) => ({
            label: String(workplace.workplace_name),
            user_id: workplace.workplace_id,
            icon: workplace.workplace_name
              ? String(workplace.workplace_name).charAt(0).toUpperCase()
              : '?',
            organization_id: newOrganization.id,
            workplace_data: {
              price: workplace.price,
              role: workplace.role,
              status: workplace.status,
              department: workplace.department_name,
            },
          }))
          : []), // если workplaces нет → пустой массив
        {
          key: 'crm',
          icon: <CRM />,
          label: 'CRM',
          authStatus: true,
          organization_id: newOrganization.id,
        },
        {
          key: 'prod',
          icon: <ProductionIcon />,
          label: 'Производство',
          authStatus: true,
          organization_id: newOrganization.id,
        },
      ];
      // Если workplaces нет, возвращаем пустой массив

      // Добавляем статичный элемент "БАЗА МАТЕРИАЛОВ" если нужно
      const subItemsWithStatic = [
        // {
        //   label: 'БАЗА МАТЕРИАЛОВ',
        //   user_id: '415364d154aw187d175aw1d418aw6d145',
        //   icon: 'БМ',
        //   organization_id: newOrganization.id,
        // },
        ...subItems, // добавляем рабочие места после статичного элемента
      ];

      setMyOrgList((prev) =>
        prev.map((org) =>
          newOrganization.id === org.id
            ? { ...org, subItems: subItemsWithStatic }
            : org
        )
      );
    } catch (error) {
      console.error('Ошибка при получении рабочих мест:', error);
    }
  };
  const handleClickMessenger = async () => {
    try {
      // Редирект
      window.location.href = window.APP_CONFIG.MESSENGER_DOMAIN;
    } catch (e) {
      console.error('Ошибка при обработке SELLER_DOMAIN:', e);
    }
  };

  const handleSubMenuItemClick = async (item) => {
    // await crateTokenAcc(organization_id, user_id);
    // // Берём домен для установки куки прямо из SELLER_DOMAIN

    if (item?.key === 'crm') {
      try {
        Cookies.set('current_organisation', item.organization_id, {
          expires: 7, // 7 дней
          domain: `.${window.APP_CONFIG?.TOKEN_DOMAIN}`, // ставим куку на основной домен
          secure: true,
          sameSite: 'None',
        });
        // Редирект
        window.location.href = window.APP_CONFIG.CRM_DOMAIN;
      } catch (e) {
        console.error('Ошибка при обработке SELLER_DOMAIN:', e);
      }
    } else if (item?.key === 'prod') {
      try {
        Cookies.set('current_organisation', item.organization_id, {
          expires: 7, // 7 дней
          domain: `.${window.APP_CONFIG?.TOKEN_DOMAIN}`, // ставим куку на основной домен
          secure: true,
          sameSite: 'None',
        });
        // Редирект
        window.location.href = 'https://multi-mir.ru';
      } catch (e) {
        console.error('Ошибка при обработке SELLER_DOMAIN:', e);
      }
    } else {

      try {
        Cookies.set('current_organisation', item.organization_id, {
          expires: 7, // 7 дней
          domain: `.${window.APP_CONFIG?.TOKEN_DOMAIN}`, // ставим куку на основной домен
          secure: true,
          sameSite: 'None',
        });
        // Редирект
        window.location.href = 'https://business-test.multi-mir.ru/mono2/';
      } catch (e) {
        console.error('Ошибка при обработке SELLER_DOMAIN:', e);
      }
    }

  };
  return (
    <div className='list-circle-menu'>
      <div className='list-circle-menu__wrapper'>
        <CircleMenu
          menuId={'menu-1'}
          isActiveCircleMenu={isActiveCircleMenu}
          items={menuItems}
          handleMenuItemClick={handleMenuItemClick}
        />
        <CircleMenu
          menuId={'menu-2'}
          isActiveCircleMenu={isActiveCircleMenuTwo}
          items={myOrgList}
          handleMenuItemClick={handleMenuClickSeller}
          handleSubMenuItemClick={handleSubMenuItemClick}
        />
      </div>
      {/* <button
        onClick={() => {
          window.location.href = 'https://test.multi-mir.ru';
        }}
        style={{ opacity: 1, top: '-50px', position: 'fixed' }}
        className=' circle-menu-item topLevel glow-effect'
      >
        <div className='circle-menu-icon'>
          М
          <svg className='circle-label' viewBox='0 0 140 140'>
            <defs>
              <path
                id='circlePath-2'
                d='M70,70 m-55,0 a55,55 0 1,1 110,0 a55,55 0 1,1 -110,0'
              ></path>
            </defs>
            <text fontSize='20' fill='aliceblue' fontWeight='400'></text>
          </svg>
        </div>
      </button> */}
    </div>
  );
};

export default ListCircleMenu;
